import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '@skbkontur/staff-common';
import classes from '../EditSidePage.module.css';
export const FormRow = ({ children, hidden, label }) => {
    if (hidden) {
        return null;
    }
    if (!label) {
        return _jsx("div", { className: classes.formRow, children: children });
    }
    return (_jsx(FieldWrapper, { label: label, className: classes.formRow, children: children }));
};
